import { Package } from '../types';

export const packages: Package[] = [
  {
    id: 'holiday-cheer',
    name: 'Holiday Cheer Package',
    price: 15,
    videoCount: 1,
    features: [
      '30-second personalized video',
      'Choice of Santa styles',
      'HD quality download',
      '48-hour delivery'
    ]
  },
  {
    id: 'family',
    name: 'Family Package',
    price: 49,
    originalPrice: 75,
    videoCount: 6,
    features: [
      '30-second personalized videos',
      'All Santa styles included',
      'HD quality downloads',
      'Priority 24-hour delivery',
      'Save 35%!'
    ]
  },
  {
    id: 'santas-sleigh',
    name: "Santa's Sleigh Package",
    price: 150,
    videoCount: 15,
    features: [
      '30-second personalized videos',
      'All Santa styles included',
      'HD quality downloads',
      'Express 12-hour delivery',
      'Priority support',
      'Custom background options'
    ]
  }
];